import React from 'react';
import SendPayments from 'Components/UI_Library/Icons/NewIconSet/SendPayments.png';
import Card from 'Components/UI_Library/Icons/NewIconSet/Card.png';
import Global from 'Components/UI_Library/Icons/NewIconSet/Global.png';
import Gears from 'Components/UI_Library/Icons/NewIconSet/Gears.png';
import classes from './SignIn.module.css';

const ProductInformation = (props) => {
    return (
        <>
            <div className={`${classes.text} ${props.noImg ? classes.noImg : ''}`}>
                <div className={classes.item}>
                    <img src={SendPayments} />
                    <div className={classes.body}>
                        <span>Send and receive payments</span>
                        <span>Domestic or global, we make it easy to pay and get paid</span>
                    </div>
                </div>
                <div className={classes.item}>
                    <img src={Global} />
                    <div className={classes.body}>
                        <span>Operate globally</span>
                        <span>Open a business account in any of the 37 currencies available</span>
                    </div>
                </div>
                <div className={classes.item}>
                    <img src={Gears} />
                    <div className={classes.body}>
                        <span>Run like clockwork</span>
                        <span>Utilise approval workflows to work better as a team</span>
                    </div>
                </div>
                <div className={classes.item}>
                    <img src={Card} />
                    <div className={classes.body}>
                        <span>Corporate cards</span>
                        <span>Replace reimbursements and have more control over employee spend</span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProductInformation;
